<template>
    <div class="YSerialNumber">
        <dsh-input
            :value="value"
            :propsObj="propsObj"
            :canEdit="false"
        ></dsh-input>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "YSerialNumber",
        mixins: [controlMixin],
        props: {},
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {}
    };
</script>

<style lang="less" scoped>
    .YSerialNumber {
        width: 100%;
    }
</style>
<style lang="less">
    .YSerialNumber {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/YSerialNumber.vue